import { apiFetch } from '../api';

export const login = (payload) => {
  return apiFetch(`/User/Login`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};
